import Image from 'next/image';
import React from 'react';

import { useTranslate } from '@/shared/hooks/use-translate';
import { theme } from '@/shared/theme';
import { Heading } from '@/shared/ui/heading';

import {
    StyledSolutionHave,
    StyledSolutionHaveContainer,
    StyledSolutionHaveImage,
    StyledSolutionHaveSteps,
    StyledSolutionHaveStepsStep,
} from './styled';

const SolutionHave: React.FC = () => {
    const { t } = useTranslate();

    return (
        <StyledSolutionHave>
            <Heading as="h2" size={theme.fontSize.xl} sizeMobile="lg" marginB="42" className="text-center">
                {t('Решение есть 🚀')}
            </Heading>
            <StyledSolutionHaveContainer>
                <StyledSolutionHaveSteps>
                    <StyledSolutionHaveStepsStep>
                        <span>
                            <Image fill src="/static/icons/man_by_computer_icon.png" alt="man by computer icon" />
                        </span>
                        {t('Выберите товар в Аренте')}
                    </StyledSolutionHaveStepsStep>
                    <StyledSolutionHaveStepsStep>
                        <span>
                            <Image fill src="/static/icons/box_icon.png" alt="box icon" />
                        </span>
                        {t('Получите его в точке выдачи')}
                    </StyledSolutionHaveStepsStep>
                    <StyledSolutionHaveStepsStep>
                        <span>
                            <Image fill src="/static/icons/firework_icon.png" alt="firework icon" />
                        </span>
                        {t('Пользуйтесь и затем верните')}
                    </StyledSolutionHaveStepsStep>
                </StyledSolutionHaveSteps>
                <StyledSolutionHaveImage>
                    <span>
                        <Image fill src="/static/images/purchases.png" alt="purchases icon" />
                    </span>
                </StyledSolutionHaveImage>
            </StyledSolutionHaveContainer>
        </StyledSolutionHave>
    );
};

export default SolutionHave;
